<template>
    <el-dialog :visible.sync="visible" :title="'周评价图'" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="init()">
            <el-form-item prop="id">
                <el-select  v-model="dataForm.id" placeholder="请选择班级" clearable filterable>
                    <el-option v-for="classManager in classList" :label="classManager.className"
                               :value="classManager.id" :key="classManager.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                        v-model="rollCallDate"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="init()">{{ $t('query') }}</el-button>
            </el-form-item>

        </el-form>
        <div id="chartColumn" style="width: 80%;width: 630px; height: 430px;" ></div>

    </el-dialog>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'week-evaluate-profile',
  data () {
    return {
      visible: false,
      dataForm: {
        startTime: '',
        endTime: '',
        id: ''
      },
      rollCallDate: '',
      gradeName: '',
      className: '',
      classList: [],
      profileList: []
    }
  },
  mounted () {
    this.init()
    this.getClassList()
    this.profilepicture()
  },
  methods: {
    init () {
      this.visible = true

      if (this.rollCallDate === null || this.rollCallDate.length <= 1) {
        this.dataForm.startTime = ''
        this.dataForm.endTime = ''
        this.rollCallDate = []
      } else {
        const date = new Date(this.rollCallDate[0])
        this.dataForm.startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '00:00:00'
        const date2 = new Date(this.rollCallDate[1])
        this.dataForm.endTime = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate() + ' ' + '23:59:59'
      }
      this.getClassList()
      this.$http.get('/classEvaluate/evaluateScore/weekProfile/', {
        params: {
          startTime: this.dataForm.startTime,
          endTime: this.dataForm.endTime,
          classId: this.dataForm.id
        }
      }).then(({ data: res }) => {
        console.log(this.dataForm)
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.prfileList = res.data
        console.log(res)
        this.profilepicture()
      }).catch(() => {
      })
    },
    profilepicture () {
      var chartDom = document.getElementById('chartColumn')
      var myChart = echarts.init(chartDom)
      myChart.setOption({
        title: {
          text: '周数据统计表'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['总分数', '得分数']
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: this.prfileList[2]
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '总分数',
            type: 'bar',
            data: this.prfileList[1],
            markPoint: {
              /* data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
                ] */
            }/*,
markLine: {
data: [
{type: 'average', name: '平均值'}
]
} */
          },
          {
            name: '得分数',
            type: 'bar',
            data: this.prfileList[0]
            /* markPoint: {
              data: [
              {name: '年最高', value: 182.2, xAxis: 7, yAxis: 183},
              {name: '年最低', value: 2.3, xAxis: 11, yAxis: 3}
              ]
              } *//*,
markLine: {
data: [
{type: 'average', name: '平均值'}
]
} */
          }
        ]
      })
    },
    getClassList () {
      this.$http.get('/classmanage/classmanage/getList/').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
      }).catch(() => {
      })
    }
  }
}
</script>
